import React from "react";
import { useLocation } from "react-router-dom";
import { ArrowLeft, Info } from "lucide-react";

/**
 * Placeholder shown at /app/* until the reverse-proxy to fertile-track is configured.
 * In production, requests to /app/* will be intercepted by the proxy layer (Vercel
 * rewrite / Nginx / Cloudflare Worker) BEFORE reaching this React app — so this page
 * should never be seen once Pattern A is in place.
 */
export default function AppProxyPlaceholder() {
    const { pathname } = useLocation();
    const target = pathname.replace(/^\/app/, "") || "/";
    return (
        <div
            className="min-h-screen flex items-center justify-center px-6"
            data-testid="app-proxy-placeholder"
            style={{ background: "linear-gradient(135deg,#f5c6d8 0%,#e8b4cc 45%,#d4a0c0 100%)" }}
        >
            <div className="max-w-lg w-full rounded-3xl bg-white/85 backdrop-blur-xl border border-white/70 p-8 shadow-[0_40px_100px_-40px_rgba(168,122,166,0.35)] text-center">
                <div className="w-14 h-14 rounded-2xl mx-auto mb-5 flex items-center justify-center"
                    style={{ background: "linear-gradient(135deg,#FCE4EC,#F9A8D4)" }}>
                    <Info className="w-6 h-6 text-femcare-pinkDeep" />
                </div>
                <h1 className="text-2xl font-extrabold text-femcare-ink tracking-[-0.02em]">
                    Web app coming soon
                </h1>
                <p className="text-sm text-femcare-inkSoft mt-3 leading-relaxed">
                    <code className="bg-femcare-blush/60 px-1.5 py-0.5 rounded text-femcare-pinkDeep font-semibold">/app{target}</code>{" "}
                    will be served by the existing FemCare app once the reverse-proxy audit is signed off.
                </p>
                <p className="text-xs text-femcare-inkSoft/70 mt-4 leading-relaxed">
                    In the meantime, the mobile app is available on the App Store and Google Play,
                    and every marketing page on <b>femcare.life</b> is fully live.
                </p>
                <a
                    href="/"
                    className="inline-flex items-center gap-2 mt-6 rounded-full px-5 py-2.5 text-sm font-semibold text-white"
                    style={{ background: "linear-gradient(135deg,#EC4899 0%,#DB2777 100%)" }}
                    data-testid="app-proxy-back-home"
                >
                    <ArrowLeft className="w-4 h-4" /> Back to FemCare
                </a>
            </div>
        </div>
    );
}
